// extracted by mini-css-extract-plugin
export var actionSelect = "_tc-0";